import { render, staticRenderFns } from "./SortComponent.vue?vue&type=template&id=2efbfd6b&scoped=true&"
import script from "./SortComponent.vue?vue&type=script&lang=js&"
export * from "./SortComponent.vue?vue&type=script&lang=js&"
import style0 from "./SortComponent.vue?vue&type=style&index=0&id=2efbfd6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbfd6b",
  null
  
)

export default component.exports